import { Tooltip } from 'flowbite-react';
import React, { useState } from 'react';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { MdError } from 'react-icons/md';

const DefaultTextarea = ({
    id,
    label,
    placeholder,
    required,
    name,
    labelClass,
    classnames = "",
    error,
    value,
    onChange,
    boxheight = false,
    onBlur,
    info = "",
    wordCount = true
}) => {
    const [wordCountError, setWordCountError] = useState(false);

    // Helper function to count words
    const countWords = (text) => {
        return text ? text.trim().split(/\s+/).length : 0;
    };

    const handleChange = (e) => {
        const newValue = e.target.value;
        const wordCount = countWords(newValue);

        // Check if word count exceeds 300
        if (wordCount > 300) {
            setWordCountError(true);
        } else {
            setWordCountError(false);
        }

        onChange(e);
    };

    return (
        <div className="flex flex-col gap-1 relative w-full">
            {label &&
                <div className="block">
                    <label
                        className={`text-theme font-medium flex items-center text-sm ${labelClass}`} htmlFor={id}
                    >
                        <span className="flex items-center gap-[2px]">
                            {label}
                            {info ?
                                <div className="cursor-pointer">
                                    <Tooltip content={info}>
                                        <IoIosInformationCircleOutline />
                                    </Tooltip>
                                </div> : null}
                        </span>
                        {required ? <span className={"text-red-600"}>*</span> : ""}
                    </label>
                </div>
            }
            <div className={`flex flex-col`}>
                <div className='flex flex-col gap-1 relative'>
                    <textarea
                        id={id}
                        placeholder={placeholder ? placeholder : `Enter ${label}`}
                        name={name}
                        onChange={handleChange}
                        onBlur={onBlur}
                        value={value}
                        className={`ring-0 focus:ring-0 focus:shadow-none focus:border-borderColor text-sm h-20 ${boxheight ? `h-${boxheight}` : 'h-20'}
                    rounded-md border-borderColor bg-light ${classnames}
                    ${(error || wordCountError) ? 'bg-red-100 rounded-md border border-red-200' : ''}`}
                    />
                    {wordCount ? <span className="text-xs text-textLight mt-1 self-end absolute right-0 -bottom-5">
                        maximum 300 words
                    </span> : null}
                </div>
                {(error || wordCountError) &&
                    <span className="flex items-center gap-1 text-sm text-error-600">
                        <MdError />
                        <p>{wordCountError ? 'Word limit exceeded. Maximum 300 words allowed.' : error}</p>
                    </span>
                }
            </div>
        </div>
    );
};

export default DefaultTextarea;
